import Keycloak from 'keycloak-js';
import { GroupsApiService } from '../hub/api/group-api.service';
import { UserService } from '../hub/api/user.service';
import {
  CustomerServiceAgentRoles,
  LoggedInUser,
  ParsedKeycloakToken,
  SelfserviceHubRoles,
} from '../hub/entities/user';

const getUserData = async (
  token: ParsedKeycloakToken,
  groupService: GroupsApiService
): Promise<LoggedInUser> => {
  const group = await groupService.fetchGroupUserData(token.contractorScope);
  const loggedInUser: LoggedInUser = {
    id: token.userScope,
    email: token.email,
    name: token.name,
    locale: token.locale,
    selfserviceAdmin: isSelfserviceAdmin(token.realm_access.roles),
    selfserviceGroupAdmin: isSelfserviceGroupAdmin(token.realm_access.roles),
    customerServiceAgent: isCustomerServiceAgent(token.realm_access.roles),
    roles: token.realm_access.roles || [],
    group,
  };
  return loggedInUser;
};

const isSelfserviceAdmin = (roles: string[] | undefined): boolean => {
  return roles ? roles.includes(SelfserviceHubRoles.SelfserviceAdmin) : false;
};

const isSelfserviceGroupAdmin = (roles: string[] | undefined): boolean => {
  return roles
    ? roles.includes(SelfserviceHubRoles.SelfserviceGroupAdmin)
    : false;
};

const isSelfserviceUser = (roles: string[] | undefined): boolean => {
  const selfserviceRoles: string[] = Object.values(SelfserviceHubRoles);
  return roles ? roles.some((role) => selfserviceRoles.includes(role)) : false;
};

const isCustomerServiceAgent = (roles: string[] | undefined): boolean => {
  if (isSelfserviceAdmin(roles)) {
    return true;
  }
  const selfserviceRoles: string[] = Object.values(CustomerServiceAgentRoles);
  return roles ? roles.some((role) => selfserviceRoles.includes(role)) : false;
};

export const loginFlow = (
  keycloak: Keycloak,
  userService: UserService,
  groupService: GroupsApiService
) =>
  // eslint-disable-next-line no-async-promise-executor
  new Promise<void>(async (resolve, reject) => {
    const token = keycloak.tokenParsed as ParsedKeycloakToken | undefined;

    if (!token) {
      console.error('Invalid token', token);
      return reject();
    }

    const userData = token ? await getUserData(token, groupService) : null;

    if (!userData) {
      console.error('Invalid userData', userData);
      return reject();
    }

    if (isSelfserviceUser(token.realm_access?.roles)) {
      userService.initializeUser(userData);
    } else {
      keycloak.logout();
    }

    resolve();
  });
